class RenderController {
    constructor() {}

    /*
    * @desc         Renderinterface to display detailed information as barchart
    * @params       settings {object} ajax result and settings
    * @return       {string}
    * */
    barchart = settings => {
        let colorCode,
            quarterTemplate = '';

        colorCode = value => {
            let c;
            if (value < settings.threshold.danger_below) {
                c = 'danger'
            } else if (value < settings.threshold.warning_below) {
                c = 'warning'
            } else {
                c = 'success'
            }

            return c;
        }

        settings.quarters.forEach((quarter, i) => {
            quarter = (quarter * 100).toFixed(1);
            if (quarter > 0 && settings.activeQuarters?.[i]) {
                quarterTemplate += `
                    <div class="progress__wrapper--small">
                        <div>
                            <span>Quartal ${i + 1}</span>
                            <span>${quarter}</span>
                        </div>
                        <div class="progress">
                            <div class="progress-bar ${colorCode(quarter)}" role="progressbar" aria-valuenow="${quarter}" aria-valuemin="0" aria-valuemax="100" style="width:${quarter}%">
                                <span class="sr-only">${quarter}% Complete</span>
                            </div>
                        </div>
                    </div>
                `
            } else if (!settings.activeQuarters?.[i]) {
                quarterTemplate += ``
            } else {
                quarterTemplate += `
                    <div class="progress__wrapper--small">
                        <div>
                            <span>Quartal ${i + 1}</span>
                            <span>n.v.</span>
                        </div>
                        <div class="progress">
                            <div class="progress-bar ${colorCode(quarter)}" role="progressbar" aria-valuenow="${quarter}" aria-valuemin="0" aria-valuemax="100" style="width:${quarter}%">
                                <span class="sr-only"></span>
                            </div>
                        </div>
                    </div>
                `
            }
        });

        const displayNaNStyle = isNaN(settings.average)  ? 'display: none;' : 'display: inline;';

        return `
            <div class="qm-tooltip hide">
                Übersicht der letzten Quartale
            </div>

            <div class="icon-info icon-info--${settings.name}"></div>

            <div class="qm-info-box qm-info-box--bars hide">
                <div class="icon-close"></div>

                <div class="progress__wrapper">
                    <span>${settings.average}<span class="inline-procent" style="${displayNaNStyle}"> %</span></span>
                    <div class="progress">
                        <div class="progress-bar ${colorCode(settings.average)}" role="progressbar" aria-valuenow="${settings.average}" aria-valuemin="0" aria-valuemax="100" style="width:${settings.average}%">
                            <span class="sr-only">${settings.average}% Complete</span>
                        </div>
                    </div>
                </div>

                <p>Detailwerte</p>

                ${quarterTemplate}
            </div>

            <span>${settings.average}<span class="inline-procent" style="${displayNaNStyle}"> %</span></span>
            <div class="progress">
                <div class="progress-bar ${colorCode(settings.average)}" role="progressbar" aria-valuenow="${settings.average}" aria-valuemin="0" aria-valuemax="100" style="width:${settings.average}%">
                    <span class="sr-only">${settings.average}% Complete</span>
                </div>
            </div>
        `;
    }
}
